<template>
  <div>
    <v-row dense>
      <v-col cols="4">
        <BTextFieldDate
          v-model="form.start_date"
          validate="required"
          :skeleton="skeleton"
          label="Начало"
          placeholder="Дата начала"
          name="start_date"
          with-buttons
          @input="onChangeDebounced"
        />
      </v-col>
      <v-col cols="4">
        <BTextFieldDate
          v-model="form.finish_date"
          validate="required"
          :skeleton="skeleton"
          label="Окончание"
          placeholder="Дата окончания"
          name="finish_date"
          with-buttons
          @input="onChangeDebounced"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="2">
        <BTooltipButton
          depressed
          text="Скачать отчёт"
          :skeleton="skeleton"
          @click="onDownloadReport"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'
import BTextFieldDate from '@/components/forms/BTextFieldDate.vue'
import BTooltipButton from '@/components/common/BTooltipButton.vue'
import { SchedulerApi } from '@/api/resources'
import { downloadLinkByPost } from '@/helpers/downloadBlob'

const createDefaultDataFilters = () => ({
  ...createDefaultData(),
  finish_date: void 0,
  start_date: void 0,
})

export default {
  name: 'SchedulerDownloadForm',
  components: {
    BTextFieldDate,
    BTooltipButton,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
  methods: {
    async onDownloadReport() {
      const api = new SchedulerApi()
      try {
        const result = await this.$validator.validate()
        if (result) {
          const url = api.getDownloadUrl()
          const data = { start_date: this.form.start_date, finish_date: this.form.finish_date }
          await downloadLinkByPost(url, data, `${this.form.start_date}-${this.form.finish_date}.xlsx`)
        }
      } catch (e) {
        this.$notice.errors(e)
      }
    },
  },
}
</script>
